import { Skeleton } from 'antd';
import { useShellText } from '@/hooks/useShellText';

export function RouteContentSkeleton() {
  const t = useShellText();
  return (
    <div role="status" aria-label={t('加载中…', 'Loading…')}>
      {/* ant-design/ant-design-pro: src/loading.tsx */}
      <Skeleton style={{ padding: '24px 40px', height: '60vh' }} active />
    </div>
  );
}

export function ApplicationSkeleton() {
  return (
    <div data-testid="application-skeleton">
      <RouteContentSkeleton />
    </div>
  );
}
